import { render } from "./threads.vue?vue&type=template&id=35763df4&scoped=true"
import script from "./threads.vue?vue&type=script&lang=js"
export * from "./threads.vue?vue&type=script&lang=js"

import "./threads.vue?vue&type=style&index=0&id=35763df4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35763df4"]])

export default __exports__